module.exports = "../images/northern-pike-fishing-ontario-2.jpg?v=914bf5b";